import './scss/index.scss';
import { dcFactory } from 'dc';
import { UtilityNavigationComponent } from './js/utility-navigation.component';
import { MicrositeNavComponent } from './js/microsite-navigation.component';

dcFactory.register(UtilityNavigationComponent);
dcFactory.register(MicrositeNavComponent);
